module.exports = __webpack_public_path__ + "img/DS1825+.f8e94765.png";